import { bigIntToLong } from '#common/util';
import { InvokeProcMsg, MetaStoreRequestMsg, ServiceBaseProto, } from '#websocket/client/proto';
import { META_STORE_REQUEST_TYPE, META_STORE_RESPONSE_TYPE } from './types';
export class InvokeProcedureRequest {
    name;
    args;
    maxKeys;
    maxSize;
    destination;
    cursor;
    constructor(name, args, maxKeys, maxSize, destination, cursor) {
        this.name = name;
        this.args = args;
        this.maxKeys = maxKeys;
        this.maxSize = maxSize;
        this.destination = destination;
        this.cursor = cursor;
    }
    createMessage(requestId, version) {
        const invokeProcMessage = InvokeProcMsg.create({
            name: this.name,
            args: this.args,
            maxKeys: bigIntToLong(this.maxKeys),
            maxSize: bigIntToLong(this.maxSize),
            cursor: this.cursor ? this.cursor : null, // eslint-disable-line no-restricted-syntax -- Communicating with protobuf interface.
        });
        const metaStoreRequest = MetaStoreRequestMsg.create({
            type: MetaStoreRequestMsg.RequestType.INVOKE_PROCEDURE_REQUEST,
            invoke: invokeProcMessage,
        });
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [META_STORE_REQUEST_TYPE]: metaStoreRequest,
        });
    }
    createResponse(responseMessage) {
        return new InvokeProcedureResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
}
export class InvokeProcedureResponse {
    result;
    constructor(response) {
        const responseMsgObject = ServiceBaseProto.ResponseMsg.toObject(response);
        this.result = responseMsgObject[META_STORE_RESPONSE_TYPE].invoke;
    }
}
